import { Route } from "@dashboard/components/Router";
import { WindowTitle } from "@dashboard/components/WindowTitle";
import { sectionNames } from "@dashboard/intl";
import { parse as parseQs } from "qs";
import { useIntl } from "react-intl";
import { type RouteComponentProps, Switch } from "react-router-dom";

import { atticApiUsagePath, type AtticApiUsageUrlQueryParams } from "./urls";
import AtticApiUsageView from "./views/AtticApiUsage";

// The range is the query string, so a view of the last 90 days is a link.
const ApiUsage = ({ location }: RouteComponentProps) => {
  const params = parseQs(location.search.replace(/^\?/, "")) as AtticApiUsageUrlQueryParams;

  return <AtticApiUsageView params={params} />;
};

// Behind VIEW_ACTIVITY_LOG (platform superusers only): the SectionRoute in
// src/index.tsx gates the whole section.
const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.atticApiUsage)} />
      <Switch>
        <Route exact path={atticApiUsagePath} component={ApiUsage} />
      </Switch>
    </>
  );
};

export default Component;
